module.exports = __webpack_public_path__ + "static/media/bt.3a828b49.svg";